import React from 'react';

import qs from "qs";
import algoliasearch from "algoliasearch/lite";
import { isEmpty } from 'lodash';

// let swipers = [];
// window["swipers"] = swipers;

const searchClient = algoliasearch(
    process.env.MIX_ALGOLIA_APP_ID,
    process.env.MIX_ALGOLIA_API_KEY,
);

const index = searchClient.initIndex('il_laravel_locations');

function urlEncode(name) {
    return name
        .split(" ")
        .map(encodeURIComponent)
        .join("+");
}

function urlDecode(slug) {
    return slug
        .split("+")
        .map(decodeURIComponent)
        .join(" ");
}

const createURL = state => {

    const isDefaultRoute =
        !state.query &&
        (!!state.page || state.page === 1) &&
        !!state.refinementList &&
        state.refinementList.mediaTags.length === 0 &&
        state.refinementList.categories.length === 0 &&
        state.refinementList.permit.length === 0 &&
        state.refinementList.city.length === 0 &&
        state.refinementList.county.length === 0 &&
        state.refinementList.access.length === 0 &&
        state.refinementList.floors.length === 0 &&
        state.refinementList.patioBalconies.length === 0 &&
        state.refinementList.pools.length === 0 &&
        state.refinementList.walls.length === 0 &&
        state.refinementList.yards.length === 0 &&
        (isEmpty(state.boundingBox) || !!!state.boundingBox);



    if (isDefaultRoute) {
        return "/search";
    }

    const queryParameters = {};

    if (state.query) {
        queryParameters.query = state.query === "" ? state.query : encodeURIComponent(state.query);
    }

    if (state.page !== 1) {
        queryParameters.page = parseInt(state.page);
    }

    if (!!state.refinementList) {

        if (state.refinementList.mediaTags) {
            queryParameters.media_tag = state.refinementList.mediaTags.map(e =>
                urlEncode(e)
            );
        }

        if (state.refinementList.categories) {
            queryParameters.category = state.refinementList.categories.map(e =>
                urlEncode(e)
            );
        }

        if (state.refinementList.permit) {
            queryParameters.permit = state.refinementList.permit.map(e =>
                urlEncode(e)
            );
        }

        if (state.refinementList.city) {
            queryParameters.city = state.refinementList.city.map(e => urlEncode(e));
        }

        if (state.refinementList.county) {
            queryParameters.county = state.refinementList.county.map(e =>
                urlEncode(e)
            );
        }

        if (state.refinementList.access) {
            queryParameters.access = state.refinementList.access.map(e =>
                urlEncode(e)
            );
        }

        if (state.refinementList.floors) {
            queryParameters.floors = state.refinementList.floors.map(e =>
                urlEncode(e)
            );
        }

        if (state.refinementList.patioBalconies) {
            queryParameters.patioBalconies = state.refinementList.patioBalconies.map(
                e => urlEncode(e)
            );
        }

        if (state.refinementList.pool) {
            queryParameters.pool = state.refinementList.pool.map(e => urlEncode(e));
        }

        if (state.refinementList.walls) {
            queryParameters.walls = state.refinementList.walls.map(e =>
                urlEncode(e)
            );
        }

        if (state.refinementList.yards) {
            queryParameters.yards = state.refinementList.yards.map(e =>
                urlEncode(e)
            );
        }
    }

    if (
        state.boundingBox &&
        state.boundingBox.northEast &&
        state.boundingBox.southWest
    ) {
        if (state.boundingBox.northEast.lat) {
            queryParameters.northEastlat = parseFloat(state.boundingBox.northEast.lat);
        }
        if (state.boundingBox.northEast.lng) {
            queryParameters.northEastlng = parseFloat(state.boundingBox.northEast.lng);
        }
        if (state.boundingBox.southWest.lat) {
            queryParameters.southWestlat = parseFloat(state.boundingBox.southWest.lat);
        }
        if (state.boundingBox.southWest.lng) {
            queryParameters.southWestlng = parseFloat(state.boundingBox.southWest.lng);
        }
    }

    const queryString = qs.stringify(queryParameters, {
        encode: false,
        addQueryPrefix: true,
        arrayFormat: "repeat"
    });

    return `${queryString}`;
};

const searchStateToUrl = searchState => {
    return searchState ? createURL(searchState) : "";
};

const urlToSearchState = location => {

    const {
        query = "",
        page = 1,
        media_tag = [],
        category = [],
        permit = [],
        city = [],
        county = [],
        access = [],
        floors = [],
        patioBalconies = [],
        pools = [],
        walls = [],
        yards = [],
        northEastlat,
        northEastlng,
        southWestlat,
        southWestlng
    } = qs.parse(location.search.slice(1));

    // `qs` does not return an array when there's a single value.
    const allMediaTags = Array.isArray(media_tag)
        ? media_tag
        : [media_tag].filter(Boolean);

    const allCategories = Array.isArray(category)
        ? category
        : [category].filter(Boolean);

    const allPermits = Array.isArray(permit)
        ? permit
        : [permit].filter(Boolean);

    const allCities = Array.isArray(city)
        ? city
        : [city].filter(Boolean);

    const allCounties = Array.isArray(county)
        ? county
        : [county].filter(Boolean);

    const allaccess = Array.isArray(access) ? access : [access].filter(Boolean);

    const allfloors = Array.isArray(floors) ? floors : [floors].filter(Boolean);

    const allpatioBalconies = Array.isArray(patioBalconies) ? patioBalconies : [patioBalconies].filter(Boolean);
    const allpools = Array.isArray(pools) ? pools : [pools].filter(Boolean);
    const allwalls = Array.isArray(walls) ? walls : [walls].filter(Boolean);
    const allyards = Array.isArray(yards) ? yards : [yards].filter(Boolean);

    let searchObject = {
        query: decodeURIComponent(query),
        page: parseInt(page),
        refinementList: {
            mediaTags: allMediaTags.map(e => urlDecode(e)),
            categories: allCategories.map(e => urlDecode(e)),
            permit: allPermits.map(e => urlDecode(e)),
            city: allCities.map(e => urlDecode(e)),
            county: allCounties.map(e => urlDecode(e)),
            access: allaccess.map(e => urlDecode(e)),
            floors: allfloors.map(e => urlDecode(e)),
            patioBalconies: allpatioBalconies.map(e => urlDecode(e)),
            pools: allpools.map(e => urlDecode(e)),
            walls: allwalls.map(e => urlDecode(e)),
            yards: allyards.map(e => urlDecode(e)),
        }
    };

    // searchObject.boundingBox = {};

    if (northEastlat || northEastlng || southWestlat || southWestlng)
        searchObject.boundingBox = { northEast: {}, southWest: {} };
    if (northEastlat)
        searchObject.boundingBox.northEast.lat = parseFloat(urlDecode(northEastlat));
    if (northEastlng)
        searchObject.boundingBox.northEast.lng = parseFloat(urlDecode(northEastlng));
    if (southWestlat)
        searchObject.boundingBox.southWest.lat = parseFloat(urlDecode(southWestlat));
    if (southWestlng)
        searchObject.boundingBox.southWest.lng = parseFloat(urlDecode(southWestlng));

    return searchObject;
};

export default (WrappedComponent) => {
    const hocComponent = ({ ...props }) =>
        <WrappedComponent
            urlToSearchState={urlToSearchState}
            searchStateToUrl={searchStateToUrl}
            searchClient={searchClient}
            createURL={createURL}
            index={index}
            {...props} />

    return hocComponent
}
